import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
} from '../../../BuildingCharacteristics.styles'
import type { DimensionsCardProps } from '../OverviewTab.types'

export const DimensionsCard: React.FC<DimensionsCardProps> = ({
  footprintArea,
  grossFloorArea,
  height,
  buildingVolume,
  buildingElevation,
  formatArea,
  formatHeight,
  t,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="ruler" size="small" />
          {t('overview.cards.dimensions.title')}
        </CardTitle>
      </CardHeader>
      <MetricGrid>
        <MetricRow>
          <MetricLabel>
            {t('overview.cards.dimensions.footprintArea')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('overview.metrics.buildingArea.tooltip.title')}
                shortDescription={t(
                  'overview.metrics.buildingArea.tooltip.description'
                )}
                calculation={t(
                  'overview.metrics.buildingArea.tooltip.calculation'
                )}
                importance={t(
                  'overview.cards.dimensions.tooltips.footprintImportance'
                )}
                source={t('overview.metrics.buildingArea.tooltip.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>{formatArea(footprintArea)}</MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('overview.cards.dimensions.grossFloorArea')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t(
                  'overview.cards.dimensions.tooltips.grossFloorArea.title'
                )}
                shortDescription={t(
                  'overview.cards.dimensions.tooltips.grossFloorArea.description'
                )}
                calculation={t(
                  'overview.cards.dimensions.tooltips.grossFloorArea.calculation'
                )}
                importance={t(
                  'overview.cards.dimensions.tooltips.grossFloorArea.importance'
                )}
                limitations={t(
                  'overview.cards.dimensions.tooltips.grossFloorArea.limitations'
                )}
                source={t(
                  'overview.cards.dimensions.tooltips.grossFloorArea.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>{formatArea(grossFloorArea)}</MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('overview.metrics.buildingHeight.label')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('overview.metrics.buildingHeight.tooltip.title')}
                shortDescription={t(
                  'overview.metrics.buildingHeight.tooltip.description'
                )}
                calculation={t(
                  'overview.cards.dimensions.tooltips.heightCalculation'
                )}
                importance={t(
                  'overview.cards.dimensions.tooltips.heightImportance'
                )}
                source={t('overview.metrics.buildingHeight.tooltip.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>{formatHeight(height)}</MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('overview.cards.dimensions.buildingVolume')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('overview.cards.dimensions.tooltips.volume.title')}
                shortDescription={t(
                  'overview.cards.dimensions.tooltips.volume.description'
                )}
                calculation={t(
                  'overview.cards.dimensions.tooltips.volume.calculation'
                )}
                importance={t(
                  'overview.cards.dimensions.tooltips.volume.importance'
                )}
                source={t('overview.cards.dimensions.tooltips.volume.source')}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {buildingVolume
              ? `${Math.round(buildingVolume).toLocaleString()} m³`
              : t('common.na')}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('overview.cards.dimensions.groundElevation')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t('overview.cards.dimensions.tooltips.elevation.title')}
                shortDescription={t(
                  'overview.cards.dimensions.tooltips.elevation.description'
                )}
                calculation={t(
                  'overview.cards.dimensions.tooltips.elevation.calculation'
                )}
                importance={t(
                  'overview.cards.dimensions.tooltips.elevation.importance'
                )}
                source={t(
                  'overview.cards.dimensions.tooltips.elevation.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {buildingElevation ? (
              <>
                {Math.round(buildingElevation).toLocaleString()} m
                <span style={{ fontSize: '12px', opacity: 0.7 }}>
                  {' '}
                  {t('overview.labels.asl')}
                </span>
              </>
            ) : (
              t('common.na')
            )}
          </MetricValue>
        </MetricRow>
      </MetricGrid>
    </Card>
  )
}
